import { useState, useEffect } from 'react';
import { PageLayoutsContainer } from '@wajeez-web/components/layouts';
import { Button } from '@wajeez-web/components/ui';
import { PlusIcon } from '@heroicons/react/solid';
import { SuperAdminSystemPermissions } from '@wajeez-web/core/types';
import { useNavigate } from 'react-router-dom';
import {
  useContentSelector,
  CollectionComponetTypesActions,
  ContentEntityTypeActions,
} from '@wajeez-web/stores/content';
import { HandleTableData } from '@wajeez-web/components/data-table';
import _ from 'lodash';
import { contentEntityDataType } from '@wajeez-web/stores/content';
import { DataTable, CheckBoxType, Dropdown } from '@wajeez-web/components/mui';
import { DotsHorizontalIcon } from '@heroicons/react/outline';

import { AssignAllowedComponentTypesModal } from '../components/AssignAllowedComponentTypesModal';
import { useGetContentEntityTypesDatatable } from '@wajeez-web/components/helpers';

const ContentEntityTypesPage = () => {
  const navigate = useNavigate();

  const [selectedContentEntityTypeId, setSelectedContentEntityTypeId] =
    useState<string>();

  const {
    tablePreferances,
    setTablePreferences,
    getData: getDatatableData,
    isTableReferencesLoading,
  } = HandleTableData(
    'ContentEntityTypes',
    ContentEntityTypeActions.getContentEntityTypesDatatableAsync,
    undefined,
    undefined,
    [{ property: 1, orderByDirection: 1 }]
  );

  const dataTableData = useGetContentEntityTypesDatatable();

  return (
    <>
      <PageLayoutsContainer
        title={`Content Entity Types`}
        endSideComponent={[
          {
            element: (
              <Button
                title={'Add'}
                Icon={PlusIcon}
                onClick={() => {
                  navigate('/content-entity-types/new');
                }}
                bg="primary"
                color="white"
              />
            ),
            permission: [SuperAdminSystemPermissions.contentEntityTypes.add],
          },
        ]}
        breadCrumbsLinks={[{ title: '' }]}
      >
        <DataTable
          dataTableData={dataTableData.data as contentEntityDataType}
          onHeaderManage={(header) => {
            const flags = header
              ?.filter((h) => h.selected)
              .reduce(
                (previousValue: number, currentValue: CheckBoxType) =>
                  previousValue + Number(currentValue.value),
                0
              );

            tablePreferances &&
              flags &&
              setTablePreferences({
                ...tablePreferances,
                flags: flags + 1,
              });
          }}
          onPaginationChange={(pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                pageSize: pagination.pageSize,
              });
          }}
          sort={tablePreferances?.sortingOperations?.[0]}
          onSort={(sort) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                sortingOperations: [sort],
              });
          }}
          onFilter={(filters, pagination) => {
            tablePreferances &&
              setTablePreferences({
                ...tablePreferances,
                pageNumber: pagination.pageNumber,
                filteringOperations: filters.map((f) => {
                  return {
                    property: Number(f.key),
                    cretiria: f.value,
                    comparisonType: f.operator,
                  };
                }),
              });
          }}
          isLoading={dataTableData.status === 'loading'}
          renderRowActions={(row) => {
            return (
              <div className="w-full flex justify-center items-center">
                <Dropdown
                  id={`action-${row[1]}`}
                  items={[
                    {
                      label: 'Edit',
                      onClick: () => {
                        navigate(`/content-entity-types/${row[1]}/edit`);
                      },
                    },
                  ]}
                  label={
                    <div style={{ color: '#343a40' }}>
                      <DotsHorizontalIcon
                        style={{ width: '28px', height: '24px' }}
                      />
                    </div>
                  }
                  buttonStyle={{
                    width: '34px',
                    minWidth: '34px',
                    paddingRight: '2px',
                    paddingLeft: '2px',
                    color: 'black',
                  }}
                />
              </div>
            );
          }}
        />
      </PageLayoutsContainer>
      {/* {isAssignAllowedComponentTypesModalOpen && (
        <AssignAllowedComponentTypesModal
          isOpen={isAssignAllowedComponentTypesModalOpen}
          onClose={() => {
            setIsAssignAllowedComponentTypesModalOpen(false);
          }}
          collectionComponentTypeId={selectedCollectionComponentTypeId}
          onSubmit={() => {
            setIsAssignAllowedComponentTypesModalOpen(false);

            tablePreferances && setTablePreferences({ ...tablePreferances });
          }}
        />
      )} */}
    </>
  );
};

export default ContentEntityTypesPage;
